import DictApi from '../../api/src/basic/api/DictApi'
import AccountApi from '../../api/src/account/api/AccountApi'
import {message} from "ant-design-vue";

const dictApi = new DictApi();
const accountApi = new AccountApi();
const state = {
    companyList: [],
    gradationList: [],
}

const mutations = {
    setCompany(state, data) {
        state.companyList = data || []
    },
    setGradation(state, data) {
        state.gradationList = data || []
    },
}

const actions = {
    // 获取所有的院校
    getAllCompany: async ({commit, state}) => {
        let data = await dictApi.getCompany();
        commit('setCompany', data)
    },

    // 获取所有的专业层次
    getGradation: async ({commit, state}) => {
        let data = await dictApi.getGradation();
        commit('setGradation', data)
    },
    login: ({commit, state}, reqData = {}) => {
        return new Promise((resolve, reject) => {
            accountApi.loginByPwd(reqData).then(res=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
                message.error(err.message)
            });
        })
    },
    loginByDD: ({commit, state}, reqData = {})=>{
        return new Promise((resolve, reject) => {
            accountApi.loginByDingCode(reqData).then((res)=>{
                resolve(res)
            }).catch(err=>{
                reject(err)
            })
        })
    },
    logout: async ({commit, state}, reqData = {}) => {
        let res = await accountApi.logout();
        return res
    }
}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}